import React from "react";
import { cn } from "@/lib/utils";

export interface CompactFormHeaderProps {
  /** Una línea corta (modo/título) → `.compact-toolbar-badge`. */
  badge?: React.ReactNode;
  /** Metadata de documento → `.compact-toolbar-meta`. */
  meta?: React.ReactNode;
  className?: string;
  /** Aplica `compact-form-header--dialog` (espacio para botón cerrar Radix). */
  dialog?: boolean;
}

/** Chrome superior de formulario: solo metadata (badge/meta). Sin acciones. */
export const CompactFormHeader: React.FC<CompactFormHeaderProps> = ({
  badge,
  meta,
  className,
  dialog = false,
}) => {
  const hasChrome = badge != null || meta != null;

  if (!hasChrome) {
    return null;
  }

  return (
    <div
      className={cn(
        "compact-form-header",
        dialog && "compact-form-header--dialog",
        className,
      )}
    >
      {meta != null ? (
        <div className="compact-toolbar-meta">{meta}</div>
      ) : (
        <span className="compact-toolbar-badge">{badge}</span>
      )}
    </div>
  );
};
